// Use window.$ directly to avoid timing issues with jQuery loading
var $ = window.$ || window.jQuery;

$(document).on('turbo:frame-load', function() {
  $('.trumbowyg-textarea').trumbowyg({
    svgPath: '/assets/icons.svg',
    plugins: {
      fontsize: {
        size_list: [
          '12px',
          '14px',
          '16px'
        ]
      }
    }
  });
});